import { useNavigate } from "react-router";

import { useDashboardStore } from "@/stores/useDashboardStore";
import { useNavigationStore } from "@/stores/useNavigationStore";
import { useRedirectStore } from "@/stores/useRedirectStore";
import { useCompaniesTableStore } from "@/stores/useTableStore";

import useChangeSelectedCompany from "../../../../../components/Navbar/components/CompanySelector/hooks/useChangeSelectedCompany";
import { useAuth } from "../../../../../context/Auth/AuthProvider";
import { ROUTES } from "../../../../../shared";
import { CCExpirationObjectDto } from "../../../types";

const useCCExpirationFunctions = () => {
  const { user } = useAuth();

  const { changeSelectedCompany } = useChangeSelectedCompany();
  const navigate = useNavigate();

  const { setParams, resetExceptPaginationAndColumns } =
    useCompaniesTableStore();
  const { setTakeToCompanies, setTakeToCompaniesCards } = useRedirectStore();

  const setIsDashboardLoading = useDashboardStore(
    state => state.setIsDashboardLoading
  );

  const handleTakeMeThereClick = async (item: CCExpirationObjectDto) => {
    resetExceptPaginationAndColumns();
    setIsDashboardLoading(true);

    if (item.companyId === user.selectedCompany.id) {
      navigate(ROUTES.Companies);
    } else {
      try {
        useNavigationStore.getState().setTargetRoute(ROUTES.Companies);

        await changeSelectedCompany(item.companyId, false, ROUTES.Companies);
      } finally {
        useNavigationStore.getState().setTargetRoute(null);
      }
    }

    setParams({
      desktopDetailsSection: true,
      selectedTableItem: item.companyId
    });

    setTakeToCompanies(item.companyId);
    setTakeToCompaniesCards(item.cardId);
  };

  return { handleTakeMeThereClick };
};

export default useCCExpirationFunctions;
